import React from "react";

function ReferralBanner() {
  return (
    <div className="new-pod-ui tw-w-full tw-py-4 md:tw-py-0 tw-relative" style={{background: '#F6F5FF'}}>
      <div className="pod-container tw-pr-5 tw-pl-5 tw-flex tw-justify-between tw-items-center">
        <div>
          <div className="tw-flex tw-items-center tw-mb-1 tw-gap-2">
            <img
              src="/images/v2/discount-shape.png"
              alt="Discount"
              className="size-48px"
            />
            <h3 className="tw-font-semibold tw-text-primary tw-mb-0 tw-text-base md:tw-text-2xl">Get N3,500 when you shop on PayOnDelivery.com</h3>
          </div>

          <p>You will get N500 sign up bonus to purchase anything and N3,000 when you refer 6 of your friends.</p>
        </div>

        <img
          src="/images/v2/discount-vector.png"
          alt="Discount Vector"
          className="tw-hidden md:tw-block"
          style={{ height: '128px', width: '157px'}}
        />

        <img
          src="/images/v2/discount-vector-full.png"
          alt="Discount Vector"
          className="tw-absolute tw-block md:tw-hidden tw-bottom-2 tw-right-2"
          style={{ height: '37.64px', width: '46.17px'}}
        />
      </div>
    </div>
  )
}

export default ReferralBanner
